// Mirrors the server cap RECORDS_IDS_MAX of the records query
export const RECORDS_CHUNK = 500;

/** Calls `read` once per chunk of at most RECORDS_CHUNK ids, passing the chunk size as limit, and joins the answers. */
export const readInChunks = async <T>(
    ids: string[],
    read: (chunk: string[], limit: number) => Promise<T[]>,
): Promise<T[]> => {
    const all: T[] = [];
    for (let i = 0; i < ids.length; i += RECORDS_CHUNK) {
        const chunk = ids.slice(i, i + RECORDS_CHUNK);
        all.push(...(await read(chunk, chunk.length)));
    }
    return all;
};
